import script from "./ButtonGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonGroup.vue?vue&type=style&index=0&id=4db942e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db942e2"]])

export default __exports__